import React from 'react';
import NumberImpact from '../assets/NumberImpact.svg';
import CommunityImpact from '../assets/CommunityImpact.svg';
import WomenImpact from '../assets/WomenImpact.svg';
import './ImpactSection.css';

const ImpactSection = () => {
  const impacts = [
    {
      title: 'By the Numbers',
      image: NumberImpact,
      items: [
        '100% Canadian-Owned',
        '500+ Vetted Drivers',
        '5,000+ Happy Riders',
        '24/7 Support Available',
        '25% EV/Hybrid Fleet'
      ]
    },
    {
      title: 'Community Impact',
      image: CommunityImpact,
      items: [
        '$10.6M in driver income generation',
        '15+ community organization partnerships',
        'Economic value retained in Canadian communities'
      ]
    },
    {
      title: "Women's Empowerment",
      image: WomenImpact,
      items: [
        '200+ women drivers earning flexible income',
        '40+ business skills workshops completed',
        "16% to 40% increase in women's transportation sector participation"
      ]
    }
  ];

  return (
    <section id="impact" className="impact-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Our Impact</h2>
        </div>
        <div className="impact-grid">
          {impacts.map((impact, index) => (
            <div className="impact-card">
              <div className="impact-image-wrapper">
                <img src={impact.image} alt={impact.title} className="impact-image" />
              </div>

              <div className="impact-content-card">
                <h3 className="impact-title">{impact.title}</h3>
                <ul className="impact-list">
                  {impact.items.map((item, idx) => (
                    <li key={idx} className="impact-item">{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImpactSection;